import {Component, Input} from '@angular/core';
import {FileUploadService} from '../../services/file-upload-service/file-upload.service';
import {BinaryData} from '../../model/proposal/binary-data';
import {UploadLocation} from '../../enum/upload-location';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {selectUserRoles} from '../../store/auth/selectors/auth.selectors';
import {Roles} from '../../enum/roles';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-download-files',
    templateUrl: './download-files.component.html',
    styleUrls: ['./download-files.component.scss'],
    standalone: false
})
export class DownloadFilesComponent {
  @Input() attachedFiles: BinaryData[];
  @Input() inBillBoard: boolean = false;
  loadingStatus: Map<string, boolean> = new Map<string, boolean>();

  roles$ = this.userStore.select(selectUserRoles);

  constructor(protected fileUploadService: FileUploadService,
              private readonly userStore: Store<UserAppState>, private readonly translate: TranslateService, private readonly snackBar: MatSnackBar) {
  }

  downloadFile(binaryData: BinaryData) {
    this.loadingStatus.set(binaryData.id, true);
    this.fileUploadService.downloadFile(binaryData.id, binaryData.secret, binaryData.name, binaryData.type).subscribe(
      () => this.loadingStatus.set(binaryData.id, false),
      _ => {
        this.loadingStatus.set(binaryData.id, false)
        this.snackBar.open(this.translate.instant('fileDownloadError'), '', {
          duration: 3000,
          panelClass: ['fail-snackbar', 'custom-snackbar']
        });
      }
    );
  }

  deleteFile(binaryData: BinaryData) {
    this.fileUploadService.deleteFileUpload(binaryData.id).subscribe({
      next: () => {
        this.attachedFiles = this.attachedFiles.filter(bd => bd.id !== binaryData.id);
        this.snackBar.open(this.translate.instant('fileDeleteSuccess'), '', {
          duration: 3000,
          panelClass: ['success-snackbar', 'custom-snackbar']
        });
      },
      error: (_) => {
        this.snackBar.open(this.translate.instant('fileDeleteError'), '', {
          duration: 3000,
          panelClass: ['fail-snackbar', 'custom-snackbar']
        });
      }
    });
  }


  protected readonly UploadLocation = UploadLocation;
  protected readonly Roles = Roles;
}
